module.exports = __webpack_public_path__ + "img/blockworld.3c95dda2.png";